/**
 * Defines the default flags for the refx ssci app
 */
export const DEFAULT_FEATURE_FLAGS: {[key: string]: 'dev' | boolean;} = {};
